module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex-content"
  }, [_vm._l((_vm.orderList['list']), function(item) {
    return _c('group', {
      key: item.id
    }, [_c('form-preview', {
      attrs: {
        "header-label": "付款金额",
        "header-value": '¥' + item.totalPrice,
        "body-items": item.list
      }
    }), _vm._v(" "), _c('flexbox', [(item.order_status !== "未付款") ? _c('flexbox-item', [_c('x-button', {
      attrs: {
        "plain": "",
        "type": "primary",
        "link": '/uc/orderDetail/' + item.id
      }
    }, [_vm._v("查看")])], 1) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('infinite-loading', {
    ref: "infiniteLoading",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('divider', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v("没有更多数据了")]), _vm._v(" "), _c('divider', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v("没有更多数据")])], 1)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64a22a4e"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uc/MemberOrder.vue
// module id = 703
// module chunks = 0